// Preview bundle entry. Loads in BOTH backoffice and the standalone configurator preview HTML route.
// MUST stay free of @umbraco-cms/backoffice imports — see memory
// feedback_plugin_bundles_no_umbraco_imports. The designer (workspace-context-aware property-editor)
// lives in a separate bundle that only loads in backoffice.

import './drill-preview.js';
import { registerItemRenderer } from '@ixit/dof-core';
import { html } from 'lit';

registerItemRenderer({
    itemType: 'drill',
    // The Drill is why `live` is required: it shipped with no branch in the designer's old
    // property-fingerprint if-chain, so an unsaved drill block never reached live Intellisense —
    // silently, because an inferred block kind has nothing to fail. `drillConfig` is the same
    // property DrillSchemaBuilder reads, and `dofDrill` the same alias it registers under;
    // declaring them is what lets the live blob reach that builder instead of a generic item.
    live: { elementTypeAlias: 'dofDrill', configProperty: 'drillConfig' },
    render: (item, state, onInputChange) => html`
        <ixit-drill-preview
            .item=${item as any}
            .state=${state as any}
            .onInputChange=${onInputChange}
        ></ixit-drill-preview>
    `,
});
